function copy(text) {
  return new Promise(function (resolve, reject) {
    var flag = copyText(text) // 传递文本
    flag ? resolve() : reject(new Error('失败'))
  })
}

function copyText(text) {
  var textarea = document.createElement('textarea') // 创建input对象
  var currentFocus = document.activeElement // 当前获得焦点的元素
  var toolBoxwrap = document.body // 将文本框插入到NewsToolBox这个之后
  var flag = false
  toolBoxwrap.appendChild(textarea) // 添加元素
  textarea.style.position = 'absolute'
  textarea.style.top = '-2000px'
  textarea.classList.add('allow-replication')
  textarea.value = text
  textarea.focus()
  if (textarea.setSelectionRange) {
    textarea.setSelectionRange(0, textarea.value.length) // 获取光标起始位置到结束位置
  } else {
    textarea.select()
  }
  try {
    flag = document.execCommand('copy') // 执行复制
  } catch (eo) {
    flag = false
  }
  toolBoxwrap.removeChild(textarea) // 删除元素
  currentFocus.focus()
  return flag
}

export default copy



// WEBPACK FOOTER //
// ./src/util/copy.js